import cookie from 'js-cookie'
import { createI18n } from 'vue-i18n'
import moment from 'moment';
import { dynamicTranslation4Rebranding } from '@zoom/billing-rebranding';
import { I18nReady } from '@/utils/ready';
import i18nEnUS from '../../i18n/en-US.json'
import { pageConfig } from '@/common/service/page-config';

window.ZBilling = window.ZBilling || {}
let i18nMessage = null;

// locale code to i18n file local code
const LocaleMap = {
  "gov-EN": "en-US",
  "en-US": "en-US",
  "es-ES": "es-ES",
  "de-DE": "de-DE",
  "zh-CN": "zh-CN",
  "zh-TW": "zh-TW",
  "fr-FR": "fr-FR",
  "pt-PT": "pt-PT",
  "jp-JP": "ja-JP",
  "ja-JP": "ja-JP",
  "ru-RU": "ru-RU",
  "ko-KO": "ko-KR",
  "ko-KR": "ko-KR",
  "it-IT": "it-IT",
  "vi-VN": "vi-VT",
  "nl-NL": "nl-NL",
  "tr-TR": "tr-TR",
  "id-ID": "id-ID",
  "pl-PL": "pl-PL",
  "sv-SE": "sv-SE",
}

export const momentI18nMap = {
  "gov-EN": "en",
  "en-US": "en",
  "es-ES": "es",
  "de-DE": "de",
  "zh-CN": "zh-cn",
  "zh-TW": "zh-tw",
  "fr-FR": "fr",
  "pt-PT": "pt",
  "jp-JP": "ja",
  "ru-RU": "ru",
  "ko-KO": "ko",
  "it-IT": "it",
  "vi-VN": "vi",
  "nl-NL": "nl",
  "tr-TR": "tr",
  "id-ID": "id",
  "pl-PL": "pl",
  "sv-SE": "sv",
}

const hreflangJson = [
  {"id":"en", "code":"en-US"},
  {"id":"es", "code":"es-ES"},
  {"id":"de", "code":"de-DE"},
  {"id":"zh-cn", "code":"zh-CN"},
  {"id":"zh-tw", "code":"zh-TW"},
  {"id":"fr", "code":"fr-FR"},
  {"id":"pt", "code":"pt-PT"},
  {"id":"ja", "code":"jp-JP"},
  {"id":"ru", "code":"ru-RU"},
  {"id":"ko", "code":"ko-KO"},
  {"id":"it", "code":"it-IT"},
  {"id":"vi", "code":"vi-VN"},
  {"id":"pl", "code":"pl-PL"},
  {"id":"tr", "code":"tr-TR"},
  {"id":"id", "code":"id-ID"},
  {"id":"nl", "code":"nl-NL"},
  {"id":"sv", "code":"sv-SE"}
];
function setMomentI18n() {
  const momentLocale = momentI18nMap[getLocale()] || "en";

  return moment.locale(momentLocale);
}

function getLocale() {
  // window._zm_lang is set by client side, reset _zm_lang in cookie if in client modal checkout
  const zmLang = window._zm_lang;
  if (zmLang && zmLang !== cookie.get('_zm_lang')) {
    let cookieDomain = document.body.getAttribute('data-cd');
    if (!cookieDomain) {
      cookieDomain = '.zoom.us';
    }
    cookie.set('_zm_lang', zmLang, { expires: 365, path: '/', domain: cookieDomain, secure: true });
  }

  const cookieLang = cookie.get('_zm_lang');
  const isGov = window.ZBilling.isGov;
  if (isGov) {
    return 'gov-EN';
  }
  return cookieLang || 'en-US';
}

export const locale = getLocale();

export function getHreflang() {
  let hreflang = 'en';

  hreflangJson.forEach(function (jsonEle) {
    if (jsonEle.code === locale) {
      hreflang = jsonEle.id;
    }
  });

  return hreflang;
}

// window.Vue.use(VueI18n)

function isNative(Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

const hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys)

function ensureCtor(comp) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default
  }
  return comp
}

export function getCurrentI18n() {
  return i18nMessage
}

export let _i18n = null

// Create a dedicated i18n instance for English translation
let enI18nInstance = null

function getEnI18nInstance() {
  if (!enI18nInstance) {
    enI18nInstance = createI18n({
      legacy: false,
      locale: 'en-US',
      fallbackLocale: 'en-US',
      messages: { 'en-US': i18nEnUS },
      warnHtmlMessage: false,
    })
  }
  return enI18nInstance
}

export function translation (i18nKey, ...params) {
  if (!i18nKey) {
    return '';
  }
  if (_i18n) {
    return _i18n.global?.t(i18nKey, ...params);
  }
  throw new Error('i18n not ready.');
}

/**
 * translate to English using vue-i18n official API
 * @param {string} key - i18n key
 * @param {array|object} args - translation parameters (array for positional params, object for named params)
 * @returns {string}
 */
export function translateToEn(key = '', args = []) {
  const enI18n = getEnI18nInstance()
  
  // vue-i18n's t() method supports both array (positional) and object (named) parameters
  // Convert empty array to undefined to use default behavior
  const params = Array.isArray(args) && args.length === 0 ? undefined : args
  
  let result = enI18n.global.t(key, params)
  
  // If translation not found, vue-i18n returns the key itself
  if (!result || result === key) {
    console.error('Invalid key or translation not found:', key)
    return ''
  }
  
  // Check if result is a string (vue-i18n might return the key if translation fails)
  if (typeof result !== 'string') {
    console.error('Invalid key, requires String type')
    return ''
  }
  
  return dynamicTranslation4Rebranding(
    () => result,
    {
      isZoomWorkplaceRebranding: pageConfig?.isZoomWorkplaceRebranding,
      sessionToWebinarPlusRename: pageConfig?.sessionToWebinarPlusRename,
      renameTeamChatToZoomChat: pageConfig?.renameTeamChatToZoomChat
    }
  )()
}

export default function resolveI18n() {
  const i18nLocale = LocaleMap[locale];
  setMomentI18n();
  return import(/* webpackChunkName: "[request]" */`../../i18n/${i18nLocale}.json`).then((res) => {
    i18nMessage = ensureCtor(res)
    _i18n = createI18n({
        legacy: false,
        locale: i18nLocale,
        fallbackLocale: 'en-US',
        messages: { 'en-US': i18nEnUS, [i18nLocale]: i18nMessage },
        warnHtmlMessage: false,
        postTranslation: (translated, key) => {
          if (typeof translated === 'string') {
            const originFn = copy => {
              if (!copy || copy?.trim?.() === '') {
                return translateToEn(key);
              }
              return copy;
            };
            return dynamicTranslation4Rebranding(
              originFn, 
              { isZoomWorkplaceRebranding: pageConfig?.isZoomWorkplaceRebranding, sessionToWebinarPlusRename: pageConfig?.sessionToWebinarPlusRename, renameTeamChatToZoomChat: pageConfig?.renameTeamChatToZoomChat },
            )(translated);
          }
          return translated;
        }
    });
    I18nReady.solved(_i18n);
    return _i18n;
  })
}
